/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon64Regular = forwardRef('DataChartBarsXUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M49.5 8A1.5 1.5 0 0 1 51 9.5v35a1.5 1.5 0 0 1-3 0v-35A1.5 1.5 0 0 1 49.5 8Z" }),
        React.createElement("path", { d: "M39 17.5a1.5 1.5 0 0 0-3 0v27a1.5 1.5 0 0 0 3 0v-27Z" }),
        React.createElement("path", { d: "M13.5 32a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-3 0v-11a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M6 55.5A1.5 1.5 0 0 1 7.5 54h49a1.5 1.5 0 0 1 0 3h-49A1.5 1.5 0 0 1 6 55.5Z" }),
        React.createElement("path", { d: "M27 25.5a1.5 1.5 0 0 0-3 0v19a1.5 1.5 0 0 0 3 0v-19Z" })));
});
